import { render, staticRenderFns } from "./jumlahKrisma.vue?vue&type=template&id=64fb32cf&scoped=true&"
import script from "./jumlahKrisma.vue?vue&type=script&lang=js&"
export * from "./jumlahKrisma.vue?vue&type=script&lang=js&"
import style0 from "./jumlahKrisma.vue?vue&type=style&index=0&id=64fb32cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb32cf",
  null
  
)

export default component.exports